var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { memo, useState } from "react";
import { Accordion } from "react-bootstrap";
// icons
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/common.scss";
// css
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/Accordion/accordion-component.scss";
var AccordionComponent = function (_a) {
    var items = _a.items;
    var _b = __read(useState([]), 2), expandedKeys = _b[0], setExpandedKeys = _b[1];
    return (React.createElement(Accordion, { alwaysOpen: true, bsPrefix: "accordion-client", onSelect: function (eventKey) {
            setExpandedKeys(eventKey);
        }, className: "d-flex flex-column gap-20" }, items.map(function (item, index) {
        var eventKey = index.toString();
        var isExpanded = expandedKeys.includes(eventKey);
        return (React.createElement(Accordion.Item, { eventKey: index.toString(), key: index, bsPrefix: "accordion-item-client", className: "d-flex flex-column gap-16" },
            React.createElement(Accordion.Header, null,
                React.createElement("div", { className: "accordion-header d-flex justify-content-between w-100" },
                    React.createElement("div", { className: "accordion-title-client d-flex align-items-center" },
                        React.createElement("i", { className: item.leftIcon }),
                        React.createElement("div", { className: "d-flex gap-1" },
                            React.createElement("p", { className: "DMSans_13_400 m-0" },
                                " ",
                                item.header),
                            (item === null || item === void 0 ? void 0 : item.optional) ? (React.createElement("p", { className: "DMSans_13_400 m-0 text-secondary-gray" }, "(Optional)")) : (React.createElement("span", { className: "redstar" }, "*")))),
                    React.createElement("div", { className: "arrow-wrap" },
                        React.createElement("i", { className: isExpanded
                                ? "chevron edel-icon-arrow-up"
                                : "chevron edel-icon-arrow-down" })))),
            React.createElement(Accordion.Body, { className: "accordion-content-client ".concat(!(item === null || item === void 0 ? void 0 : item.optional) && "bg-transparent p-0") }, item.body)));
    })));
};
export default memo(AccordionComponent);
